import crypto from 'crypto'
const ENCRYPTION_KEY = 'ezCk24raQeYi9BFHLR67kJGAUFpc46Fg'
const BUFFER_KEY = '66rb8gXYxVY6HpGB'
const ENCRYPT_METHOD = 'aes-256-cbc'
const ENCODING = 'hex'

export function encrypt(raw: any) {
  const iv = Buffer.from(BUFFER_KEY)
  const cipher = crypto.createCipheriv(
    ENCRYPT_METHOD,
    Buffer.from(ENCRYPTION_KEY),
    iv
  )
  let encrypted = cipher.update(raw)

  encrypted = Buffer.concat([encrypted, cipher.final()])

  return encrypted.toString(ENCODING)
}

export function decrypt(encrypted: any) {
  const iv = Buffer.from(BUFFER_KEY)
  const encryptedText = Buffer.from(encrypted, ENCODING)
  const decipher = crypto.createDecipheriv(
    ENCRYPT_METHOD,
    Buffer.from(ENCRYPTION_KEY),
    iv
  )
  let decrypted = decipher.update(encryptedText)

  decrypted = Buffer.concat([decrypted, decipher.final()])

  return decrypted.toString()
}
